import { ResponseDataType } from "@/models/types"
import { BaseClass } from "./base"
import { ResourceDto } from "@/models/dtos"
import { CreateResourceBase64Args, QueryResourceArgs } from "@/models/args"

export class ResourceClass extends BaseClass{
  gets(args: QueryResourceArgs){
    return this.get<ResponseDataType<ResourceDto>>('/api/Resource', args)
  }

  create(data: FormData){
    return this.upload<ResourceDto>('/api/Resource', data)
  }

  createBase64(data: CreateResourceBase64Args){
    return this.post<ResourceDto>('/api/Resource/AddExtBase64', data)
  }

  remove(id){
    return this.delete<number>(`/api/Resource/${id}`)
  }

  removeFile(id: number, projectNo: string){
    return this.get<number>('/api/Resource/Delete', {id, projectNo})
  }
}